
import './App.css';
import Home from './pages/Home';

import WebDev from './pages/webDev';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import DrinkCampaignPage from './pages/DrinkCampaignPage';
import About from './pages/About';
import Contact from './pages/Contact';
import Footer from './components/Footer';

import AlphaBuilders from './pages/AlphaBuilders';
import Eventure from './pages/Eventure';
import BetweenChoirs from './pages/BetweenChoirs';
import BetweenBands from './pages/BetweenBands';
import PeaceOfHeart from './pages/PeaceOfHeart';
import Flashroom from './pages/Flashroom';

function App() {
  return (
    <div className="App">

      <Router>


        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='/projects' element={<WebDev />} />


          <Route path='/drinkcampaign' element={<DrinkCampaignPage />} />
          <Route path='/alphabuilders' element={<AlphaBuilders />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/eventure' element={<Eventure />} />
          <Route path='/betweenchoirs' element={<BetweenChoirs />} />
          <Route path='/betweenbands' element={<BetweenBands />} />
          <Route path='/therapistwebsite' element={<PeaceOfHeart />} />
          <Route path='/flashroom' element={<Flashroom />} />

        </Routes>
        <Footer />


      </Router>

    </div>
  );
}

export default App;
